//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular, { IAngularBootstrapConfig } from 'angular';

const oldBootstrap = angular.bootstrap;

// These types are from angularjs's type definitions. So we'll leave them as is.
export function originalAngularBootstrap(
  element: string | Element | JQuery | Document,
  modules?: (string | (() => void) | unknown[])[],
  config?: IAngularBootstrapConfig,
): angular.auto.IInjectorService {
  return oldBootstrap.call(angular, element, modules, config);
}
